<div class="main">
  <!-- Template - Mobile -->
  <div class="mobile_template">
    <!-- Header - Mobile-->
    <div class="mobile_header" [formGroup]="miFormulario">
      <div class="mobile_header_superior">
        <!-- Language -->
        <div class="mobile_header_language">
          <mat-button-toggle-group formControlName="languageControl">
            <mat-button-toggle value="en">
              <span>EN</span>
            </mat-button-toggle>
            <mat-button-toggle value="es">
              <span>SP</span>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <!-- Plant-->
        <!-- <div class="mobile_header_select-plant">
          <mat-icon aria-label="Plant">business</mat-icon>
          <mat-form-field appearance="fill">
            <div class="mobile_header_select-plant-option">
              <mat-select formControlName="selectedPlant">
                <mat-option *ngFor="let plant of plants" [value]="plant.code" [ngClass]="'header_select-plant-text'">
                  {{ plant.name }}
                </mat-option>
              </mat-select>
            </div>
          </mat-form-field>
        </div> -->
      </div>
      <div class="mobile_header_inferior">
        <!-- Burger -->
        <div class="mobile_header_burger">
          <button mat-icon-button class="menu-button" (click)="sidenav.toggle()">
            <mat-icon>{{ isMenuOpen ? 'menu_open' : 'menu' }}</mat-icon>
          </button>
        </div>
        <!-- User -->
        <div class="mobile_header_user">
          <!-- ID -->
          <button mat-icon-button class="header_user-name" mat-button [matMenuTriggerFor]="myProfile">
            <mat-icon aria-label="My Profile">person</mat-icon>
          </button>
          <!-- Data and actions -->
          <mat-menu class="header_user-menu" #myProfile="matMenu">
            <label class="header_user-menu-name" mat-menu-item>{{user.name}}</label>
            <button mat-menu-item [routerLink]="['/home/change_password']">{{'label_change_password' | translate
              }}</button>
            <button (click)="logout()" mat-menu-item>
              <mat-icon>logout</mat-icon>{{'log-out' | translate }}
            </button>
          </mat-menu>
        </div>
        <!-- Logo -->
        <div class="mobile_header_logo">
          <img src="./assets/images/components/logoSchaeffler.svg">
        </div>
      </div>
    </div>
  </div>
  <!-- Template - Desk -->
  <div class="desk">
    <!-- Header - Desk -->
    <header>
      <app-header></app-header>
    </header>
  </div>
  <!--General Content-->
  <div class="container" style="max-width: 100%;">
    <!-- Menu - Desk -->
    <nav>
      <app-menu></app-menu>
    </nav>
    <!-- Menu - Mobile -->
    <mat-sidenav-container class="mobile_menu_sidenav-container">
      <mat-sidenav #sidenav autoFocus="false" mode="over" [(opened)]="isMenuOpen" class="sidenav">
        <div class="menu_mobile">
          <div class="menu_mymenu" *ngIf="!isAdmin else admin">
            <div class="menu_list">
              <div class="menu_list_title">
                <label>Supplier Menu</label>
              </div>
              <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                (click)="onSidenavClick()">
                <div class="menu_list_mark"></div>
                <a [routerLink]="['/home']">
                  <mat-icon class="menu_list_icon" aria-label="Home">home</mat-icon>
                  <span>Home (Dashboard)</span>
                </a>
                <div class="separator"></div>
              </div>
              <div class="menu_list_element sub" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu_list_mark"></div>
                <div class="menu_list_link">
                  <a [routerLink]="['/home/inspection/news']" (click)="onSidenavClick()">
                    <mat-icon class="menu_list_icon" aria-label="New Inspections">zoom_in</mat-icon>
                    <span>New Inspections</span>
                  </a>
                  <mat-icon class="sub_icon" [ngClass]="isOpenNewInspections ? 'open' : 'closed'"
                    (click)="verNewInspections();">keyboard_arrow_down</mat-icon>
                </div>
                <div class="separator"></div>
              </div>
              <div class="submenu" [@toggleBox]="isOpenNewInspections ? 'open' : 'closed'" (click)="onSidenavClick()">
                <div class="menu_list_element" routerLinkActive="active">
                  <div class="menu_list_mark"></div>
                  <a [routerLink]="['/home/inspection/new_inspection/']">
                    <mat-icon class="menu_list_icon" aria-label="Detail">reorder</mat-icon>
                    <span>Detail</span>
                  </a>
                  <div class="separator"></div>
                </div>
              </div>
              <div class="menu_list_element sub">
                <div class="menu_list_mark"></div>
                <a (click)="verSub();">
                  <mat-icon class="menu_list_icon" aria-label="CertificationInspections">search</mat-icon>
                  <span>Certification Inspections</span>
                  <mat-icon class="sub_icon" [ngClass]="isOpen ? 'open' : 'closed'">keyboard_arrow_down</mat-icon>
                </a>
                <div class="separator"></div>
              </div>
              <div class="submenu" [@toggleBox]="isOpen ? 'open' : 'closed'" (click)="onSidenavClick()">
                <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <div class="menu_list_mark"></div>
                  <a [routerLink]="['/home/inspection/data_registrationB']">
                    <mat-icon class="menu_list_icon" aria-label="DataRegistrationB">edit_note</mat-icon>
                    <span>Data Registration</span>
                  </a>
                  <div class="separator"></div>
                </div>
              </div>
            </div>
          </div>
          <ng-template #admin>
            <div class="menu_admin">
              <div class="menu_list">
                <div class="menu_list_title">
                  <label>Admin Menu</label>
                </div>
                <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <div class="menu_list_mark"></div>
                  <a [routerLink]="['/admin']">
                    <mat-icon class="menu_list_icon" aria-label="Home">home</mat-icon>
                    <span>Home</span>
                  </a>
                  <div class="separator"></div>
                </div>
                <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <div class="menu_list_mark"></div>
                  <a [routerLink]="['/home/inspection/plans']">
                    <mat-icon class="menu_list_icon" aria-label="DataRegistrationB">list_alt</mat-icon>
                    <span>Inspection Plans</span>
                  </a>
                  <div class="separator"></div>
                </div>
                <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                  (click)="goToInspectionScheduller()">
                  <div class="menu_list_mark"></div>
                  <a [routerLink]="['/admin/scheduler']">
                    <mat-icon class="menu_list_icon" aria-label="DataRegistrationB">edit_notifications</mat-icon>
                    <span>Inspection Scheduler</span>
                  </a>
                  <div class="separator"></div>
                </div>

                <div class="menu_list_element sub">
                  <div class="menu_list_mark"></div>
                  <a (click)="openOtherAdmin();">
                    <mat-icon class="menu_list_icon"
                      aria-label="CertificationInspections">admin_panel_settings</mat-icon>
                    <span>Admin Section</span>
                    <mat-icon class="sub_icon"
                      [ngClass]="isOtherOpenAdmin ? 'open' : 'closed'">keyboard_arrow_down</mat-icon>
                  </a>
                  <div class="separator"></div>
                </div>


                <div class="submenu" [@toggleBox]="isOtherOpenAdmin ? 'open' : 'closed'">
                  <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <div class="menu_list_mark"></div>
                    <a [routerLink]="['/home/supplier_list']">
                      <mat-icon class="menu_list_icon" aria-label="InspectionDetail">people</mat-icon>
                      <span>{{ "button-supplier-list" | translate}}</span>
                    </a>
                    <div class="separator"></div>
                  </div>
                </div>

                <div class="submenu" [@toggleBox]="isOtherOpenAdmin ? 'open' : 'closed'">
                  <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <div class="menu_list_mark"></div>
                    <a [routerLink]="['/home/dashboard']">
                      <mat-icon class="menu_list_icon" aria-label="InspectionDetail">insert_chart</mat-icon>
                      <span>Dashboard Metrics</span>
                    </a>
                    <div class="separator"></div>
                  </div>
                </div>


                <div class="menu_list_element sub">
                  <div class="menu_list_mark"></div>
                  <a (click)="openSubAdmin();">
                    <mat-icon class="menu_list_icon" aria-label="CertificationInspections">preview</mat-icon>
                    <span>Review Inspections</span>
                    <mat-icon class="sub_icon"
                      [ngClass]="isOpenAdmin ? 'open' : 'closed'">keyboard_arrow_down</mat-icon>
                  </a>
                  <div class="separator"></div>
                </div>
                <div class="submenu" [@toggleBox]="isOpenAdmin ? 'open' : 'closed'">
                  <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <div class="menu_list_mark"></div>
                    <a>
                      <mat-icon class="menu_list_icon" aria-label="InspectionDetail">info</mat-icon>
                      <span>Inspection Detail</span>
                    </a>
                    <div class="separator"></div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </mat-sidenav>
      <mat-sidenav-content>
        <main>
          <!-- Content -->
          <router-outlet></router-outlet>
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>